/**
 * Determines whether the current browser host should render the Control Panel UI.
 *
 * - Prefer explicit env-defined hostnames when set.
 * - Still fall back to any hostname that starts with "control." so production
 *   host moves do not break if an older exact hostname is still present in env.
 */
export function isControlHost() {
  if (typeof window === 'undefined') return false;

  const host = window.location.hostname.toLowerCase();
  const configuredHosts = [
    process.env.REACT_APP_CONTROL_DOMAIN,
    ...(process.env.REACT_APP_CONTROL_HOSTS || '').split(','),
  ]
    .map((value) => String(value || '').trim().toLowerCase())
    .filter(Boolean);

  if (configuredHosts.includes(host)) return true;
  return host.startsWith('control.');
}
